<template>
  <div v-if="!hasOrganizerAccess && !loadingProfile">
    <no-data-message v-if="nonOrganizerText">
      <v-icon slot="icon">flag</v-icon>
      <template slot="message">
        {{ nonOrganizerText }}
      </template>
    </no-data-message>
  </div>
  <div v-else-if="loadingProfile" class="loader-container">
    <loader></loader>
  </div>
  <v-app v-else class="white" v-scroll="onScroll">
    <div class="white pb-2 main">
      <div class="main">
        <v-container fluid class="pa-0">
          <!-- headers and filters -->
          <div class="header-view">
            <v-layout row wrap class="pb-3">
              <v-flex xs12 sm7>
                <v-layout row wrap>
                  <v-btn flat icon @click="toggleFilter= !toggleFilter"><i class="filter-icon pr-2"></i></v-btn>
                  <v-btn flat icon @click="toggleSearchTask=!toggleSearchTask"><i class="search-icon pr-4"></i></v-btn>
                  <input v-if="toggleSearchTask" type="text" placeholder="search" v-model="searchTaskValue" @keyup="searchTasks(searchTaskValue)" class="search-input pl-2">
                </v-layout>
              </v-flex>
            </v-layout>
            <div v-if="toggleFilter" class="filter-view">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm4 class="pr-4">
                    <v-layout column wrap>
                      <v-layout row wrap class="input-container">
                        <v-flex xs12 sm5 lg2 class="">
                          <label for="project">Project</label>
                        </v-flex>
                        <v-flex xs12 sm7 lg10>
                          <project-search v-model="filterFields.projectsFilter"></project-search>
                        </v-flex>
                      </v-layout>

                      <!-- project type -->
                      <v-layout column wrap class="pt-4 pb-4 checkbox-section">
                        <h5>Project type</h5>
                        <v-layout row wrap>
                          <v-flex xs6 sm6>
                            <v-checkbox
                              label="Local"
                              color= 'blue'
                              v-model='filterFields.taskLocal'
                            >
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs6 sm6>
                            <v-checkbox
                              label="Virtual"
                              v-model="filterFields.taskVirtual"
                              color= 'blue'
                            >
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm4 class="pr-4">
                    <v-layout column wrap>
                      <v-layout row wrap class="input-container">
                        <v-flex xs12 sm4 lg2>
                          <label for="status">Status</label>
                        </v-flex>
                        <v-flex xs12 sm8 lg10>
                          <v-select
                            flat
                            :items="status"
                            item-text="text"
                            item-value="value"
                            solo
                            class="select"
                            placeholder="Status"
                            v-model="filterFields.statusFilter"
                          >
                          </v-select>
                        </v-flex>
                      </v-layout>
                      <v-layout column wrap class="pt-4 pb-4 checkbox-section">
                        <h5>Days left</h5>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-checkbox
                              label="< 1"
                              color='blue'
                              value="<1"
                              v-model ="filterFields.taskDaysLeft[0]"
                            >
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs4>
                            <v-checkbox
                              label="1-3"
                              color='blue'
                              value="1-3"
                              v-model ="filterFields.taskDaysLeft[1]"
                            >
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs4>
                            <v-checkbox
                              label="3+"
                              color='blue'
                              value="3+"
                              v-model ="filterFields.taskDaysLeft[2]"
                            >
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm4>
                    <v-layout column wrap>
                      <v-layout row wrap class="input-container">
                        <v-flex xs12 sm4 lg3>
                          <label for="frequency">Frequency</label>
                        </v-flex>
                        <v-flex xs12 sm8 lg9>
                          <v-select
                            flat
                            solo
                            class="select"
                            placeholder="Frequency"
                            :items="frequency"
                            items-text= "text"
                            item-value= "value"
                            v-model= "filterFields.frequencyFilter"
                          >
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>

          <div v-if="!dataLoading && !loadingProfile && noTasks" class="centered mt-4">
            <no-data-message>
              <v-icon slot="icon">event_note</v-icon>
              <template slot="message">
                There are no effort items to show
              </template>
              <template slot="sub-message">
                You can start by creating a new effort
              </template>
              <template slot="button">
                <button @click="addNewTask">
                  Create Effort
                </button>
              </template>
            </no-data-message>
          </div>
          <div v-else class="task-view" v-for="task in organizerTasks" :key="task.task_id">
            <v-layout row wrap align-end class="list-elements">
              <v-flex xs12 sm5 class="py-2">
                <div class="project-name caption">
                  <router-link class="project__link" :to="{name: 'ProjectOverview', params: {id: task.project_id} }">
                    {{ task.project_name }}
                  </router-link>
                </div>
                <div class="task-name" @click="toTaskDetails(task.task_id)">
                  {{ task.task_name || task.task_ref }}
                </div>
              </v-flex>


              <v-flex xs12 sm4 align-center class="task__metrics py-2">
                <span v-if="task.task_status">
                  <span class="status white--text" :class="getStatusClass(task.task_status)">
                    <span class="status__text">
                      {{ getStatusText(task.task_status) }}
                    </span>
                  </span>
                </span>

                <span v-if="task.completion_type">
                  <v-icon class="small-icon" :class="getCompletionType(task.completion_type)"></v-icon>
                </span>

                <span v-if="task.task_contributors">
                  <v-icon class="small-icon" title="Followers" style="color: #cccfd5">remove_red_eye</v-icon>
                  <span class="ml-1 sub-headers">{{ task.task_contributors }}</span>
                </span>

                <span v-if="task.task_contributors">
                  <v-icon title="Registered" class="profile-grey-icon small-icon"></v-icon>
                  <span class="ml-1 sub-headers">{{ task.task_registered }}</span>
                </span>

                <span v-if="task.task_completions">
                  <v-icon title="Completed Tasks" class="completions-grey-icon small-icon"></v-icon>
                  <span class="ml-1 sub-headers">{{ task.task_completions }}</span>
                </span>

                <span v-if="task.task_time_to_start">
                  <v-icon title="Time to start" class="clock-grey-icon small-icon"></v-icon>
                  <span class="ml-1">{{ taskDuration(task.task_time_to_start ) }}</span>
                </span>
              </v-flex>

              <!-- actions -->
              <v-flex xs12 sm3 class="py-2">
                <v-layout row wrap class="task__actions">
                  <v-tooltip top>
                    <v-btn slot="activator" icon class="action-icons" :to="toTaskEdit(task.task_id)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <span>Edit</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn slot="activator" icon class="action-icons" @click="copyTaskDetailsLink(task.task_id)">
                      <v-icon>link</v-icon>
                    </v-btn>
                    <span>Copy Effort Details</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn slot="activator" icon class="action-icons" @click="copyRefLink(task.task_ref)">
                      <v-icon>done_all</v-icon>
                    </v-btn>
                    <span>Copy Ref</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn slot="activator" icon class="action-icons" :to="{name: 'TaskDetailsPeople', params: {id: task.task_id}}">
                      <v-icon>people</v-icon>
                    </v-btn>
                    <span>People List</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn slot="activator" icon class="action-icons" :to="{name: 'OrganizerCompletions', query: { effort_id: task.task_id }}">
                      <v-icon>list</v-icon>
                    </v-btn>
                    <span>Completions</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn slot="activator" icon class="action-icons" disabled>
                      <v-icon>assessment</v-icon>
                    </v-btn>
                    <span>Completion Summary</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn slot="activator" icon class="action-icons" :to="toTaskChat(task.task_id)">
                      <v-icon>chat</v-icon>
                    </v-btn>
                    <span>Chat</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="dataLoading" class="loader-container">
            <loader></loader>
          </div>
        </v-container>
      </div>
      <div v-if="!dataLoading && !noTasks">
        <div class="add-btn">
          <v-btn large class="fixed-primary-button white--text" @click="addNewTask()" >Add Effort</v-btn>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import { compact, get, throttle } from 'lodash';
import moment from 'moment';
import Loader from '@/components/Loader';
import clipboard from '@/mixins/clipboard';
import organizer from '@/mixins/organizer';

import ProjectSearch from '@/components/shared/ProjectSearch';

import { getNewTaskId, getNewProjectId } from '@/api';

export default {
  components: {
    Loader,
    ProjectSearch,
  },
  mixins: [clipboard, organizer],
  data() {
    return {
      toggleFilter: false,
      toggleSearchTask: false,
      searchTaskValue: '',
      status: [
        { value: '-1', text: 'All' },
        { value: '0', text: 'Pending' },
        { value: '1', text: 'Live' },
        { value: '2', text: 'In Progress' },
        { value: '3', text: 'Completed' },
        { value: '4', text: 'Archived' },
      ],
      frequency: [
        { value: '-1', text: 'All' },
        { value: 'unique', text: 'Unique' },
        { value: 'multi', text: 'Multi' },
      ],
      filterFields: {
        projectsFilter: null,
        taskLocal: false,
        taskVirtual: false,
        statusFilter: null,
        frequencyFilter: null,
        taskDaysLeft: [],
      },
    };
  },
  methods: {
    onScroll() {
      const scroll = this.$scrollPercent();
      const scrollingUp = this.lastScroll > scroll;
      this.lastScroll = scroll;

      if (scroll < 0.90 || scrollingUp) return null;

      this.$store.dispatch('organizer/getOrganizerTasks');
      return null;
    },
    copyRefLink(taskRef) {
      const routeName = this.$router.resolve({
        name: 'DirectCompletionQuestions',
        params: { ref: taskRef },
      });
      const origin = window.location.origin;
      this.clipboard(`${origin}/${routeName.href}`);
      this.$store.dispatch('auth/setFlashMessage', { message: 'Effort Reference link has been copied to clipboard.', type: 'success' });
    },
    copyTaskDetailsLink(taskId) {
      const routeName = this.$router.resolve({
        name: 'TaskDetails',
        params: { id: taskId },
      });
      const origin = window.location.origin;
      this.clipboard(`${origin}/${routeName.href}`);
      this.$store.dispatch('auth/setFlashMessage', { message: 'Effort detail link has been copied to clipboard.', type: 'success' });
    },
    toTaskChat(taskId) {
      return { name: 'TaskDetailsChat', params: { id: taskId } };
    },
    toTaskEdit(taskId) {
      return { name: 'TaskEdit', params: { id: taskId } };
    },
    toProjectDetails(projectId) {
      return { name: 'ProjectOverview', params: { id: projectId } };
    },
    toTaskDetails(taskId) {
      this.$router.push({ name: 'TaskDetails', params: { id: taskId } });
    },
    getStatusText(value) {
      let statusText = '';
      switch (value) {
        case '0':
          statusText = 'Pending';
          break;
        case '1':
          statusText = 'Live';
          break;
        case '2':
          statusText = 'In Progress';
          break;
        case '3':
          statusText = 'Completed';
          break;
        case '4':
          statusText = 'Archived';
          break;
        default:
          break;
      }
      return statusText;
    },
    getStatusClass(value) {
      let statusClass = '';
      switch (value) {
        case '0':
          statusClass = 'pending';
          break;
        case '1':
          statusClass = 'live';
          break;
        case '2':
          statusClass = 'inprogress';
          break;
        case '3':
          statusClass = 'completed';
          break;
        case '4':
          statusClass = 'archived';
          break;
        default:
          break;
      }
      return statusClass;
    },
    getCompletionType(value) {
      let completionType;
      switch (value) {
        case 'multi':
          completionType = 'many-grey-icon';
          break;
        case 'unique':
          completionType = 'single-grey-icon';
          break;
        default:
          completionType = 'many-grey-icon';
          break;
      }
      return completionType;
    },
    searchTasks: throttle(function searchTasks(query) {
      this.$store.dispatch('organizer/taskReset');
      this.$store.dispatch('organizer/searchOrganizerTasks', query);
    }, 1000),
    searchProjects(query) {
      this.$store.dispatch('organizer/searchOrganizerProjects', query);
    },
    taskDuration(value) {
      if (value === null) {
        return '-';
      }
      const duration = moment().add(value, 'seconds');
      return duration.fromNow();
    },
    addNewTask() {
      const userToken = this.$store.getters['auth/userToken'];
      getNewTaskId(userToken)
        .then(({ data }) => {
          const taskId = get(data, '[1].data.details.task_id');
          this.$router.push({ name: 'TaskEdit', params: { id: taskId } });
        });
    },
    addNewProject() {
      const userToken = this.$store.getters['auth/userToken'];
      getNewProjectId(userToken)
        .then(({ data }) => {
          const projectId = get(data, '[1].data.details.project_id');
          this.$router.push({ name: 'ProjectEdit', params: { id: projectId } });
        });
    },
    filterTasks() {
      // reset the tasks list first to accomodate the new filtered results
      this.$store.dispatch('organizer/taskReset');
      this.$store.dispatch('organizer/getOrganizerTasks', this.filterParams);
    },
  },
  computed: {
    noTasks() {
      return this.organizerTasks.length === 0;
    },
    organizerTasks: {
      get() {
        return this.$store.getters['organizer/organizerTasks'];
      },
    },
    dataLoading() {
      return this.$store.getters['organizer/tasksLoading'];
    },
    projectsSelect: {
      get() {
        return [{ project_id: '-1', project_name: 'All' }, ...this.$store.getters['organizer/projectsSelect']];
      },
    },
    filterParams() {
      const expectedFields = {
        project_id: null,
        task_virtual: null,
        task_status: null,
        frequency_filter: null,
        task_days_left: [],
      };

      if (this.filterFields.taskLocal === true && this.filterFields.taskVirtual === true) {
        delete expectedFields.task_virtual;
      } else if (this.filterFields.taskLocal === false && this.filterFields.taskVirtual === false) {
        delete expectedFields.task_virtual;
      } else if (this.filterFields.taskVirtual === true && this.filterFields.taskLocal === false) {
        expectedFields.task_virtual = 1;
      } else if (this.filterFields.taskVirtual === false && this.filterFields.taskLocal === true) {
        expectedFields.task_virtual = 0;
      }

      if (this.filterFields.projectsFilter === '-1' || this.filterFields.projectsFilter === null) {
        delete expectedFields.project_id;
      } else {
        expectedFields.project_id = this.filterFields.projectsFilter;
      }

      if (this.filterFields.statusFilter === '-1' || this.filterFields.statusFilter === null) {
        delete expectedFields.task_status;
      } else {
        expectedFields.task_status = this.filterFields.statusFilter;
      }

      if (this.filterFields.frequencyFilter === '-1' || this.filterFields.frequencyFilter === null) {
        delete expectedFields.frequency_filter;
      } else {
        expectedFields.frequency_filter = this.filterFields.frequencyFilter;
      }

      if (compact(this.filterFields.taskDaysLeft).length === 0) {
        delete expectedFields.task_days_left;
      } else {
        expectedFields.task_days_left = compact(this.filterFields.taskDaysLeft);
      }

      return expectedFields;
    },
  },
  watch: {
    filterFields: {
      deep: true,
      handler: 'filterTasks',
    },
  },
  mounted() {
    this.$store.dispatch('organizer/taskReset');
    this.$store.dispatch('shared/setDataLoading', true);
    this.$store.dispatch('organizer/getOrganizerProjectsBasicDetails');

    const projectId = this.$route.query.project;
    if (projectId) {
      this.filterFields = { ...this.filterFields, projectsFilter: projectId };
    }

    this.$store.dispatch('organizer/getOrganizerTasks', this.filterParams);
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.mt-6 {
  margin-top: 6px;
}

.mt2 {
  margin-top: 2px;
}

.main {
  height: 100%;
}

.task-view:nth-child(odd) {
  background: $filter-background;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 80%;
}

.input-container {
  border-color: $border-color;
  background: white;
  .input-group.input-group--solo {
    box-shadow: none;
  }
}

.status {
  min-width: 50px;
  font-size: 13px;
  border-radius:3px;
  padding: 3px;
  color: white;
}

.pending {
  background: $pending;
}

.live {
  background: $live;
}

.completed {
  background: $completed;
}

.inprogress {
  background: $inprogress;
}

.archived {
  background: $filter-background;
}

.fixed-primary-button {
  background: $primary;
  font-family: MuseoSans-900;
  text-align: center;
  border-radius: 24px;
  padding: 1px;
}

.header-view {
  border-bottom: 1px solid #e5e5e5;
}

.task-actions {
  span {
    color: $blue;
    font-size: 13px;
  }
}

.add-btn {
  position: fixed;
  bottom: 5px;
  left: calc(50% - 70px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  margin-bottom: 20px;
}


@media only screen and (max-width:600px) {
  .add-btn {
    margin-bottom: 70px;
  }
}

@media only screen and (min-width:1600px) {
  .add-btn {
    left: calc(50vw + 100px);
  }
}

.list-elements {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 16px;
  line-height: 2;
  padding-right: 16px;
  .btn {
    min-width: auto;
  }
}

// filter-view is to apply css to the filter icons corresponding entries
.filter-view {
  padding: 16px;
  background: $filter-background;
  .input-container {
    label {
      padding-left: 2px;
      color: $blue;
      font-family: MuseoSans-500;
      font-size: 16px;
    }
  }
}

.search-input:focus {
  outline: none;
  border-bottom: 1px solid $blue;
  width: 80%;
  font-size: 16px;
}

.action-icons.btn.btn--icon {
  color: #7e7e7e;
}

.task__metrics > span {
  display: inline-block;
  color: $placeholder;
  font-size: 12px;
}


.task__metrics > span::after {
  content: '\00B7';
  color: $placeholder;
  font-weight: bold;
  margin: 0 10px;
}

.task__metrics > span:last-child::after {
  display: none;
}

.status__text {
  display: inline-block;
  min-width: 100px;
  text-align: center;
}

.project-name {
  color: $light;
}

.task-name {
  font-size: 16px;
  color: $blue;
  cursor: pointer;
}

.task__actions {
  display: flex;
  justify-content: flex-end;
}

.project__link {
  text-decoration: none;
  color: inherit;
}

.half-circle-spinner {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganizerTasks.vue